"use client";

import { Event } from "@/db/schema";
import { deleteEvent } from "@/lib/deleteEvent";
import { combineCallbacks, createToastCallbacks, withCallbacks } from "@/utils/withCallbacks";
import { authClient } from "@/lib/auth-client";
import { useActionState, useMemo } from "react";
import SubmitButton from "../common/SubmitButton";

export const DeleteEventButton = ({
  requireAuth,
  event,
  onDelete,
}: {
  requireAuth: boolean;
  event: Event;
  onDelete: () => void;
}) => {
  const { data: activeMemberRole } = authClient.useActiveMemberRole();
  const { data: sessionData } = authClient.useSession();

  const [, formAction, isPending] = useActionState(
    withCallbacks(
      deleteEvent,
      combineCallbacks(createToastCallbacks(), {
        onSuccess: onDelete,
      }),
    ),
    null,
  );

  const admin = useMemo(() => {
    const role = activeMemberRole?.role;
    if (!role) return false;
    return role.split(",").some((r) => r === "admin" || r === "owner");
  }, [activeMemberRole?.role]);

  const creator = useMemo(() => {
    if (!requireAuth) return true;
    return sessionData?.user.id === event.clerkId;
  }, [requireAuth, sessionData?.user.id, event.clerkId]);

  if (admin || creator)
    return (
      <form action={formAction} className="w-full">
        <input type="hidden" name="id" value={event.id} />
        <SubmitButton
          text="Delete"
          isPending={isPending}
          variant={"destructive"}
          className="w-full"
        />
      </form>
    );

  return null;
};
